import React from 'react';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { IconButton } from '@material-ui/core';
import OfficeInfo from './OfficeInfo';
import { MarketData } from '../../types';

interface OfficePopupProps {
  selectedMarket: MarketData;
  setSelectedOffice: (market: MarketData) => void;
  handleClose: () => void;
}

const OfficePopup = ({
  selectedMarket,
  setSelectedOffice,
  handleClose,
}: OfficePopupProps) => {
  return (
    <div>
      {selectedMarket && (
        <OfficeInfo
          selectedMarket={selectedMarket}
          closePopoutButton={
            <IconButton
              onClick={handleClose}
              onAnimationEnd={() => setSelectedOffice(null)}
            >
              <KeyboardArrowRightIcon />
            </IconButton>
          }
        />
      )}
    </div>
  );
};

export default OfficePopup;
